<template>
  <div>
    <div class="uploader__wrapper flex">
      <div
        v-for="(item, index) in uploadData"
        :key="index"
        class="showImage"
        @click="previewImg(item, index)"
      > 
        <img class="image" v-if="item.url" :src="item.base64Url" alt="" />
      </div>
      <img
        class="image__img"
        v-if="uploadData.length < 3"
        src="@/assets/images/appeal_icon_upload.png"
        alt=""
        @click="handleClick"
      />
    </div>
    <input
      type="file"
      ref="uploadFile"
      accept="image/*"
      style="display: none"
      @change="getfile"
    />
  </div>
</template>

<script>
import pictureCompress from "picture-compressor";
import EXIF from "exif-js";
export default {
  components: {},
  props: {
    uploadData: {
      type: Array,
      default: () => {},
    },
    itemInfo: {
      type: Object,
      default: () => {},
    },
    isUploadBotton: {
      type: Boolean,
      default: true,
    },
    reportStatus: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  mounted () {
  },
  methods: {
    previewImg(item, index) {
      this.$emit("previewImg", { item, index });
    },
    handleClick() {
      this.$refs.uploadFile.click();
    },
    getfile(e) {
      var self = this;
      const file = e.target.files[0];
      self.$refs.uploadFile.value = "";
      // EXIF 用于获取图片方向，处理ios 拍照问题
      EXIF.getData(file, function () {
        const orientation = EXIF.getTag(this, "Orientation") || 1;
        self.compressImg(file, orientation);
      });
    },
    compressImg(file, orientatio) {
      const self = this;
      let rotate = 0;
      //纠正方向
      switch (orientatio) {
        case 1:
          rotate = 0;
          break;
        case 3:
          rotate = 180;
          break;
        case 6:
          rotate = 90;
          break;
        case 8:
          rotate = -90;
          break;
      }
      // 进行压缩
      const fr = new FileReader();
      fr.readAsDataURL(file);
      fr.onload = function (event) {
        pictureCompress({
          img: event.target.result,
          width: 2400,
          height: 2400,
          quality: 0.8,
          rotate: rotate,
        }).then((res) => {
            // 返回值进行服务上传
            self.$emit("base64Upload", {
              serveSrc: res.img.split(",")[1],
              pageSrc: res.img,
            });
          })
          .catch(() => {
            self.$toast("上传失败，请重新上传");
          });
      };
    },
  },
};
</script>

<style scoped lang="less">
.flex {
  display: flex;
  flex-wrap: wrap;
  padding: 0px 24px;
}
.uploader__wrapper {
  .image {
    width: 148px;
    height: 148px;
    margin-right: 40px;
    border-radius: 14px;
  }
  .image_r {
    margin-right: 0;
  }
  .image__img {
    width: 152px;
    height: 153px;
  }
}
.showImage {
  margin-bottom: 41px;
}
</style>
